import { useEventCallback } from '@cian/react-utils';
import { useRef } from 'react';

/**
 * Предотвращает нежелательное событие клика на слайде,
 * когда слайдер перемещается с помощью мыши.
 */
export const useSlideClick = () => {
  const mouseXRef = useRef(0);

  const onSlideMouseDown = useEventCallback((e: React.MouseEvent<HTMLDivElement>) => {
    mouseXRef.current = e.clientX;
  });

  const onSlideClickCapture = (e: React.MouseEvent<HTMLDivElement>) => {
    if (mouseXRef.current !== e.clientX) {
      e.stopPropagation();
    }
  };

  return { onSlideMouseDown, onSlideClickCapture };
};
